export default class Archive {
    constructor() {
        this.selects = document.querySelectorAll('select')
        this.form = document.querySelector('form')

        this.selects.forEach((el) => {
            el.addEventListener('change', () => {
                this.form.submit()
            })
        })
    }

}